(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awl-bundle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-awl-bundle-cta]').forEach(function(a){
      a.addEventListener('click', function(e){
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var t = document.querySelector(href);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history && history.pushState) { try { history.pushState(null, '', href); } catch (err) {} }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-buybox"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return '$' + (c/100).toFixed(2); }
    function init(root){
      var form = root.querySelector('.awl-bb__form'); if (!form) return;
      var data = root.querySelector('[data-awl-variants]');
      var variants = data ? JSON.parse(data.textContent) : [];
      var variant = variants[0] || {};
      var unit = parseInt(root.getAttribute('data-unit'), 10) || (variant.price || 0);
      var bundlePrice = parseInt(root.getAttribute('data-bundle-price'), 10) || 0;
      var bundleId = root.getAttribute('data-bundle-id');
      var idInput = form.querySelector('[data-awl-id]');
      var qtyInput = form.querySelector('[data-awl-qtyinput]');
      var planInput = form.querySelector('[data-awl-planinput]');
      var freq = form.querySelector('[data-awl-freq]');
      var qty = 1, subscribe = !!form.querySelector('[data-awl-plan="sub"]'), bundle = false;

      function planId(){ return freq ? freq.value : ''; }
      function subUnit(){
        var pid = planId();
        if (variant.selling_plan_allocations) {
          var a = variant.selling_plan_allocations.find(function(x){ return String(x.selling_plan_id) === String(pid); });
          if (a) return a.per_delivery_price || a.price;
        }
        return Math.round(unit * 0.8);
      }
      function perUnit(){ return subscribe ? subUnit() : unit; }
      function savePct(){ var s = subUnit(); return unit ? Math.round((1 - s/unit) * 100) : 0; }

      function render(){
        var pu = perUnit();
        [1,2,3].forEach(function(i){
          var now = form.querySelector('[data-tier-now="'+i+'"]');
          var strike = form.querySelector('[data-tier-strike="'+i+'"]');
          var per = form.querySelector('[data-tier-per="'+i+'"]');
          var save = form.querySelector('[data-tier-save="'+i+'"]');
          if (now) now.textContent = money(pu * i);
          if (strike) strike.textContent = subscribe ? money(unit * i) : '';
          if (per) per.textContent = money(pu) + ' / ' + (root.dataset.unitword || 'tub');
          if (save) save.textContent = subscribe ? ('Save ' + savePct() + '%') : '';
        });
        var sp = form.querySelector('[data-awl-subprice]'); if (sp) sp.textContent = money(subUnit() * qty);
        var ss = form.querySelector('[data-awl-substrike]'); if (ss) ss.textContent = money(unit * qty);
        var op = form.querySelector('[data-awl-oneprice]'); if (op) op.textContent = money(unit * qty);
        var total = (bundle && bundlePrice) ? bundlePrice : (pu * qty);
        var t = form.querySelector('[data-awl-total]'); if (t) t.textContent = money(total);
        var al = form.querySelector('[data-awl-addlabel]'); if (al) al.textContent = (root.dataset.addbase || 'Add to Cart') + ' — ' + money(total);
        if (idInput) idInput.value = variant.id || idInput.value;
        if (qtyInput) qtyInput.value = qty;
        if (planInput) planInput.value = subscribe ? planId() : '';
      }

      var slides = root.querySelectorAll('[data-awl-slide]');
      var thumbs = root.querySelectorAll('[data-awl-thumb]');
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var idx = t.getAttribute('data-awl-thumb');
          slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-awl-slide') === idx); });
          thumbs.forEach(function(x){ x.classList.toggle('is-active', x === t); });
        });
      });

      var stage = root.querySelector('.awl-bb__stage');
      if (stage) stage.addEventListener('click', function(){ stage.classList.toggle('is-zoomed'); });

      form.querySelectorAll('[data-awl-size]'); // noop guard
      var sizes = form.querySelectorAll('.awl-bb__size');
      sizes.forEach(function(btn){
        btn.addEventListener('click', function(){
          sizes.forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var rec = parseInt(btn.getAttribute('data-rec'), 10) || 1;
          setQty(rec);
          var note = form.querySelector('[data-awl-sizenote]');
          if (note) note.innerHTML = 'Most ' + btn.querySelector('.lbl').textContent.toLowerCase() + ' dogs need <b>' + rec + ' ' + (root.dataset.unitword || 'tub') + (rec > 1 ? 's' : '') + '</b> for the 30-day rebuild.';
        });
      });
      function setQty(n){
        qty = n;
        form.querySelectorAll('[data-awl-qty]').forEach(function(b){ b.classList.toggle('is-active', parseInt(b.getAttribute('data-awl-qty'),10) === n); });
        render();
      }
      form.querySelectorAll('[data-awl-qty]').forEach(function(b){
        b.addEventListener('click', function(){ setQty(parseInt(b.getAttribute('data-awl-qty'),10) || 1); });
      });
      function selectPlan(radio){
        if (!radio) return;
        form.querySelectorAll('[data-awl-plan]').forEach(function(r){ r.checked = false; });
        radio.checked = true;
        subscribe = radio.getAttribute('data-awl-plan') === 'sub';
        form.querySelectorAll('.awl-subw__card').forEach(function(c){ c.classList.remove('is-active'); });
        var card = radio.closest('.awl-subw__card'); if (card) card.classList.add('is-active');
        render();
      }
      form.querySelectorAll('[data-awl-plan]').forEach(function(radio){
        radio.addEventListener('change', function(){ selectPlan(radio); });
      });
      // Robust click handler on the entire card so the hidden radios always toggle reliably
      form.querySelectorAll('.awl-subw__card').forEach(function(card){
        card.addEventListener('click', function(e){
          if (e.target.closest('select, option, a')) return;
          e.preventDefault();
          selectPlan(card.querySelector('[data-awl-plan]'));
        });
      });
      if (freq) freq.addEventListener('change', render);
      var bt = form.querySelector('[data-awl-bundle-toggle]');
      var bcb = bt ? bt.querySelector('[data-awl-bundle-check]') : null;
      function syncBundle(){
        bundle = bcb ? !!bcb.checked : bundle;
        if (bt) bt.classList.toggle('is-checked', bundle);
        render();
      }
      if (bcb) bcb.addEventListener('change', syncBundle);
      if (bt) bt.addEventListener('click', function(e){
        if (e.target.tagName === 'A') return;
        // Suppress native label/input toggle so we control the state in one place
        e.preventDefault();
        if (bcb) bcb.checked = !bcb.checked;
        syncBundle();
      });

      form.addEventListener('submit', function(e){
        var bundleChecked = bcb ? !!bcb.checked : bundle;
        if (!bundleChecked || !bundleId) return;
        e.preventDefault();
        // Bundle is an upgrade that REPLACES the standalone purchase
        // (the bundle SKU already contains the chews + paw protector + wipes)
        var items = [{ id: bundleId, quantity: 1 }];
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function(r){
          if (r.ok) { window.location.href = '/cart'; }
          else { form.submit(); }
        }).catch(function(){ form.submit(); });
      });

      render();
    }
    function boot(){ document.querySelectorAll('[data-awl-bb]').forEach(init); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-dosing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initTimeline(tl){
      var items = tl.querySelectorAll('.awl-tl-item');
      var fill = tl.querySelector('.awl-timeline__fill');
      function update(){
        var trigger = window.innerHeight * 0.6;
        var tlTop = tl.getBoundingClientRect().top;
        var lastY = 16;
        items.forEach(function(it){
          var r = it.getBoundingClientRect();
          var active = (r.top + 16) <= trigger;
          it.classList.toggle('is-active', active);
          if (active) { lastY = (r.top - tlTop) + 16; }
        });
        if (fill) { fill.style.height = Math.max(0, lastY - 16) + 'px'; }
      }
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
    function boot(){ document.querySelectorAll('.awl-timeline').forEach(initTimeline); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-finalcta"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-awl-finalcta]').forEach(function(a){
      a.addEventListener('click', function(e){
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var t = document.querySelector(href);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history && history.pushState) { try { history.pushState(null, '', href); } catch (err) {} }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-packselector"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(form){
      var cards = form.querySelectorAll('[data-awl-card]');
      var idInput = form.querySelector('[data-awl-packid]');
      var totalEl = form.querySelector('[data-awl-packtotal]');
      function render(card){
        cards.forEach(function(c){ c.classList.remove('is-active'); });
        card.classList.add('is-active');
        if (idInput) idInput.value = card.getAttribute('data-variant');
        if (totalEl) totalEl.textContent = '— ' + card.getAttribute('data-price');
      }
      cards.forEach(function(card){ card.addEventListener('click', function(){ render(card); }); });
      var active = form.querySelector('[data-awl-card].is-active') || cards[0];
      if (active) render(active);
    }
    function boot(){ document.querySelectorAll('[data-awl-pack]').forEach(init); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-reviews-compact"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.awl-reviews-compact a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var hash = a.getAttribute('href');
        if (!hash || hash === '#') return;
        var target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history && history.pushState) { try { history.pushState(null, '', hash); } catch (err) {} }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var bar = document.querySelector('[data-awl-stickyatc]');
    if (!bar) return;
    function getTriggerY() {
      var reasons = document.querySelectorAll('.awl-reason');
      if (reasons.length < 2) return 9999999;
      var r2 = reasons[1];
      return r2.getBoundingClientRect().bottom + window.scrollY;
    }
    function getHideY() {
      var buybox = document.querySelector('.awl-bb, .awl-buybox-sec, [data-awl-bb]');
      if (!buybox) return Infinity;
      return buybox.getBoundingClientRect().top + window.scrollY;
    }
    var triggerY = getTriggerY();
    var hideY = getHideY();
    var ticking = false;
    function check() {
      ticking = false;
      var topOfViewport = window.scrollY;
      var bottomOfViewport = topOfViewport + window.innerHeight;
      var show = topOfViewport > triggerY - 100 && bottomOfViewport < hideY;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(check); ticking = true; }
    }
    function recalc() { triggerY = getTriggerY(); hideY = getHideY(); check(); }
    recalc();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recalc);
    window.addEventListener('load', recalc);
    setTimeout(recalc, 600);
    setTimeout(recalc, 1500);

    var cta = bar.querySelector('[data-awl-stickyatc-cta]');
    if (cta) {
      cta.addEventListener('click', function(e){
        var href = cta.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var t = document.querySelector(href);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history && history.pushState) { try { history.pushState(null, '', href); } catch (err) {} }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awl-ugc"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function setup(card){
      var btn = card.querySelector('[data-awl-ig-play]');
      var vid = card.querySelector('video');
      if (!btn) return;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if (!vid) return;
        if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function(){}); card.classList.add('is-playing'); }
        else { vid.pause(); card.classList.remove('is-playing'); }
      });
      if (vid) {
        vid.addEventListener('ended', function(){ card.classList.remove('is-playing'); });
        vid.addEventListener('click', function(){ if (!vid.paused) { vid.pause(); card.classList.remove('is-playing'); } });
      }
    }
    function boot(){ document.querySelectorAll('[data-awl-ig]').forEach(setup); }
    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
